import { CLICKED_HEALTH_ID, HEALTH_REC_TYPES, HEALTH_REC_TYPES_FAILED, HEALTH_REC_TYPES_SUCCESS, HEALTH_REC_UPLOAD, HEALTH_REC_UPLOAD_FAILED, HEALTH_REC_UPLOAD_SUCCESS, HEALTH_RECORD_REQUEST, HEALTH_RECORD_REQUEST_ERROR, HEALTH_RECORD_REQUEST_SUCCESS } from './Constants';

// userReducer.js
const initialState = {
    loading: false,
    error: null,
};
  
export const healthRecordReducer = (state = initialState, action) => {
    switch (action.type) {
    case HEALTH_RECORD_REQUEST:        
        return { ...state, loading: true };
    case HEALTH_RECORD_REQUEST_SUCCESS :                
        return { ...state, healthRecords : action.payload, page : action.page, loading: false };
    case HEALTH_RECORD_REQUEST_ERROR :
        return { ...state,loading: false };
    case CLICKED_HEALTH_ID :
        return { ...state, healthId : action.healthId };
    case HEALTH_REC_TYPES:        
        return { ...state,msg : null, loading: true };
    case HEALTH_REC_TYPES_SUCCESS :                
        return { ...state, healthRecordTypes : action.payload, loading: false };
    case HEALTH_REC_TYPES_FAILED :
        return { ...state,loading: false };
    case HEALTH_REC_UPLOAD:        
        return { ...state, loading: true };
    case HEALTH_REC_UPLOAD_SUCCESS :                    
        return { ...state, msg : action.payload, loading: false };
    case HEALTH_REC_UPLOAD_FAILED :
        return { ...state,loading: false };
    default:
        return state;
    }
};
  